module.exports = __webpack_public_path__ + "assets/img/rakulogo.a904a73f.png";